import _ from "lodash";
import { getCurrentPathname } from "services/NavigationService";
import {
  createOrganizationV2Mutation,
  createOrganizationPresetMutation,
  updateOrganizationPresetMutation,
  deleteOrganizationPresetMutation,
  approveOrganizationMutation,
  approveUserMutation,
  deleteApproveSchoolRequestMutation,
  deleteApproveUserRequestMutation,
  updateOrganizationAcademicYearMutation,
  createOrganizationAcademicYearMutation,
  editStandardInfoMutation,
  deleteOrganizationMutation,
  updateConfigurablePermissionMutation,
  deleteStandardMutation,
  internalToolsGenericMutation,
  updateBaseProgressReportTemplateMutation,
  updateOrganizationPaidStatusMutation,
  updateCurriculumProgramsMutation,
  updateOrganizationBasicDetailsMutation,
  validateInternalToolsModulePasswordMutation,
  createGenericConfigurationMutation,
  upsertConfigurationViewMutation,
  editGenericConfigurationMutation,
  addConfigurationValuesMutationV2,
  bulkRemoveUsersFromMultiAccessIdentityMutation,
  createMultiAccessIdentityMutation,
  editMultiAccessIdentityMutation,
  removeUserFromMultiAccessIdentityMutation,
  deleteConfigurationValueMutation,
  updateConfigurationEntityValueMutation,
  addConfigurationValuesMutationV1,
  addUsersToMultiAccessIdentityMutation,
  removeUserIdentityFromMultiAccessIdentityMutation,
  toggleConfigurationStateMutation,
  configurationCacheFlushMutation,
  configurationMultiValueUpsertMutation,
  createOrganizationAccessRequestForUserMutation,
  createMultiAccessIdentityUserAccessRequestMutation,
  editRequestForOrganizationAccessMutation,
  editRequestForUserAccessMutation,
  editSchoolCloudStorageAccountMutation,
  createSurveyRulesetMutation,
  createCompleteSurveyMutation,
  deleteMultiAccessIdentityRequestMutation,
  createOrganizationAccountMutation,
  updateAccountDetailsMutation,
  deleteCurriculumProgramMutation,
  bulkUpdateConfigurationMutation,
} from "./ToolingMutations";
import { setPortalType } from "Login/modules/LoginModule";
import { PORTAL_TYPE_BY_REGION } from "Platform/routes/Regions/modules/Module";
import { getIsChina } from "config";

import update from "immutability-helper";
import {
  getAllOrganizationQuery,
  getOrganizationApprovalRequestFeed,
  getUserApprovalRequestFeed,
  getStandardFeedQuery,
  getAcademicYears,
  getOrganizationFeedQuery,
  fetchAllClassesOfOrgQuery,
  getProgressReportBaseTemplateQuery,
  getGenericConfigurationsFeedQuery,
  getConfigurationDetailsQuery,
  bulkDownloadOrganizationDataQuery,
  getManageLinkedUsersFeedQuery,
  getMultiAccessIdentityFeedQuery,
  generateConfigurationDMLQuery,
  getConfigurationValuesQuery,
  getOrganizationPermissionRequestQuery,
  getOrganizationUserAccessRequestQuery,
  getSurveyFeedQuery,
  getRuleSetFeedQuery,
  getCurriculumProgramByPlatformIdQuery,
} from "./ToolingQueries";
import { goToRelativeRoute } from "modules/Services";
import { bulkUploadByFileMutation } from "modules/CommonMutations";
import { setToastMsg } from "Login/modules/LoginModule";
import client from "lib/apolloClient/client";
import { colors } from "Constants";
import moment from "moment";
import { generateRandomId, dispatchError, hexToArgbObject } from "Utils";
import FileSaver from "file-saver";
import { getConfigurationsFilters, getToastMsg } from "./ToolingUtils";
import { REGION_FILTER_OPTIONS } from "Platform/routes/Regions/modules/Module";
import { getOrganizationFeedQuery as getOrganizationFeedQueryForProgrammes } from "Tooling/routes/ManageProgrammes/modules/ManageProgrammesQueries";
import { getConfigurationQuery } from "ChildrenPage/modules/ChildrenPageQuery";

export const NAME = "tooling";

export const CHANGE_ORGANIZATION_SEARCH_STRING =
  "CHANGE_ORGANIZATION_SEARCH_STRING" + " " + NAME;

export const CHANGE_RULESET_SEARCH_STRING =
  "CHANGE_RULESET_SEARCH_STRING" + " " + NAME;

export const CHANGE_USER_SEARCH_STRING =
  "CHANGE_USER_SEARCH_STRING" + " " + NAME;

export const CHANGE_STANDARD_SEARCH_STRING =
  "CHANGE_STANDARD_SEARCH_STRING" + " " + NAME;

export const SET_IS_LOADING_STATE = "SET_IS_LOADING_STATE" + " " + NAME;
export const TOGGLE_ACTION_LOADING = "TOGGLE_ACTION_LOADING" + " " + NAME;
export const UPDATE_FILTERS = "UPDATE_FILTERS" + " " + NAME;
export const CHANGE_SEARCH_TERM = "CHANGE_SEARCH_TERM" + " " + NAME;
export const INIT_SEARCH_TERM = "INIT_SEARCH_TERM" + " " + NAME;
export const UPDATE_TEACHER_OBJECT = "UPDATE_TEACHER_OBJECT" + " " + NAME;
export const UPDATE_TEACHER_STEP = "UPDATE_TEACHER_STEP" + " " + NAME;
export const INIT_TEACHER_OBJECT = "INIT_TEACHER_OBJECT" + " " + NAME;
export const TOGGLE_TEACHER_TABS = "TOGGLE_TEACHER_TABS" + " " + NAME;
export const INIT_REMOVED_COURSES = "INIT_REMOVED_COURSES" + " " + NAME;
export const TOGGLE_REMOVED_COURSES = "TOGGLE_REMOVED_COURSES" + " " + NAME;
export const TOGGLE_MANAGE_COURSE_ROUTE =
  "TOGGLE_MANAGE_COURSE_ROUTE" + " " + NAME;
export const UPDATE_ORGANIZATION_FILTERS =
  "UPDATE_ORGANIZATION_FILTERS" + " " + NAME;
export const UPDATE_CURRICULUM_PROGRAMMES_FILTERS =
  "UPDATE_CURRICULUM_PROGRAMMES_FILTERS" + " " + NAME;
export const INIT_CURRICULUM_PROGRAMMES_FILTERS =
  "INIT_CURRICULUM_PROGRAMMES_FILTERS" + " " + NAME;
export const SET_IS_PASSWORD_VAILD = "SET_IS_PASSWORD_VAILD" + " " + NAME;
export const SET_IS_LOADING = "SET_IS_LOADING" + " " + NAME;
export const UPDATE_CONFIGURATION_SORT_ORDER =
  "UPDATE_CONFIGURATION_SORT_ORDER" + " " + NAME;
export const UPDATE_CONFIGURATION_DETAILS =
  "UPDATE_CONFIGURATION_DETAILS" + " " + NAME;
export const INIT_CONFIGURATION_DETAILS =
  "INIT_CONFIGURATION_DETAILS" + " " + NAME;
export const UPDATE_CONFIGURATION_REMOVED_ITEMS =
  "UPDATE_CONFIGURATION_REMOVED_ITEMS" + " " + NAME;
export const UPDATE_CONFIGURATION_VALUES_DETAILS =
  "UPDATE_CONFIGURATION_VALUES_DETAILS" + " " + NAME;
export const UPDATE_CONFIGURATION_VIEW_VALUE_DETAILS =
  "UPDATE_CONFIGURATION_VIEW_VALUE_DETAILS" + " " + NAME;
export const INIT_CONFIGURATION_REMOVE_VALUE =
  "INIT_CONFIGURATION_REMOVE_VALUE" + " " + NAME;

export const initConfigurationRemoveValue = () => {
  return { type: INIT_CONFIGURATION_REMOVE_VALUE };
};

export const updateOrganizationFilters = data => {
  return { type: UPDATE_ORGANIZATION_FILTERS, data };
};

export const updateCurriculumProgrammesFilters = data => {
  return { type: UPDATE_CURRICULUM_PROGRAMMES_FILTERS, data };
};

export const initCurriculumProgrammesFilters = data => {
  return { type: INIT_CURRICULUM_PROGRAMMES_FILTERS, data };
};

export const changeOrganizationSearchString = payload => {
  return { type: CHANGE_ORGANIZATION_SEARCH_STRING, payload };
};

export const changeRuleSetSearchString = payload => {
  return { type: CHANGE_RULESET_SEARCH_STRING, payload };
};

export const changeUserSearchString = payload => {
  return { type: CHANGE_USER_SEARCH_STRING, payload };
};

export const changeStandardSearchString = payload => {
  return { type: CHANGE_STANDARD_SEARCH_STRING, payload };
};

export const setIsLoadingState = payload => {
  return { type: SET_IS_LOADING_STATE, payload };
};

const GRAY_OUT_COLUMNS = [
  "Toddle ID",
  "Unique ID",
  "First Name",
  "Last Name",
  "Email",
  "Role",
  "Old Class List",
];

const ERROR_CODE_TO_MSG_MAPPING = {
  "TD/UPGDMC/001": "toastMsgs:grades_cannot_be_deleted_msg",
  "TD/UPGDMC/002": "toastMsgs:grades_mapped_with_year_groups_cannot_be_deleted",
  "TD/INSMAIUR/006": "toastMsgs:invalid_user_id",
};

//User Feed

export const updateFilters = data => {
  return {
    type: UPDATE_FILTERS,
    data,
  };
};

export const updateConfigurationViewValueDetails = payload => {
  return {
    type: UPDATE_CONFIGURATION_VIEW_VALUE_DETAILS,
    payload,
  };
};

export const updateConfigurationsSortOrder = payload => {
  return { type: UPDATE_CONFIGURATION_SORT_ORDER, payload };
};

export const updateConfigurationDetails = payload => {
  return { type: UPDATE_CONFIGURATION_DETAILS, payload };
};

export const updateConfigurationRemovedItems = payload => {
  return { type: UPDATE_CONFIGURATION_REMOVED_ITEMS, payload };
};

export const initConfigurationDetails = () => {
  return { type: INIT_CONFIGURATION_DETAILS };
};

export const updateConfigurationValuesDetails = payload => {
  return { type: UPDATE_CONFIGURATION_VALUES_DETAILS, payload };
};

export const changeSearchTerm = value => {
  return { type: CHANGE_SEARCH_TERM, payload: value };
};

//

export const onClickNavigate = data => {
  return (dispatch, getState) => {
    if (typeof data === "object") {
      const { link, type } = data;

      dispatch(goToRelativeRoute({ route: link, type }));
    } else dispatch(goToRelativeRoute({ route: data, type: "push" }));
  };
};

export const updateBaseProgressReportTemplate = (id, body) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateBaseProgressReportTemplateMutation,
        variables: {
          id,
          body,
        },
        refetchQueries: [
          {
            query: getProgressReportBaseTemplateQuery,
            variables: {
              id,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:template_successfully_updated",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
};

export const createMultiAccessIdentity = ({
  variables = {},
  setIsLoading,
  feedFilters,
}) => {
  return async (dispatch, getState) => {
    try {
      setIsLoading(true);
      await client.mutate({
        mutation: createMultiAccessIdentityMutation,
        variables: {
          input: {
            ...variables,
          },
        },
        refetchQueries: [
          {
            query: getMultiAccessIdentityFeedQuery,
            variables: {
              filters: feedFilters,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

/**
 * This mutation gets called from two pages
 * Module A: Access Manager Page (All Identities list page)
 * Module B: Manage Access of Identity Page
 */
export const bulkRemoveUsersFromMultiAccessIdentity = ({
  variables = {},
  setIsLoading,
  feedFilters,
  source,
}) => {
  return async (dispatch, getState) => {
    try {
      let refetchQuery;
      if (source === "linkedUsersPage") {
        // Module B: refetch
        refetchQuery = {
          query: getManageLinkedUsersFeedQuery,
          variables: feedFilters,
        };
      } else if (source === "platformAccessManager") {
        // Module A: refetch
        refetchQuery = {
          query: getMultiAccessIdentityFeedQuery,
          variables: {
            filters: feedFilters,
          },
        };
      }

      setIsLoading(true);
      const response = await client.mutate({
        mutation: bulkRemoveUsersFromMultiAccessIdentityMutation,
        variables: {
          input: {
            ...variables,
          },
        },
        refetchQueries: mutationResult => {
          const count = _.get(
            mutationResult,
            "data.platform.bulkRemoveUsersFromMultiAccessIdentity.updatedIdentityUserConnectionCount"
          );

          // Special Case: if count is 0, and mutation called is from Module B, then refetch the query from Module A
          // Reason: In case of count = 0, we are removing the multi access identity row, and redirecting user back to Module A. Hence, it is necessary to refetch the query from Module A.
          if (source === "linkedUsersPage" && count === 0) {
            return [
              {
                query: getMultiAccessIdentityFeedQuery,
                variables: {
                  filters: {
                    first: 30,
                    tagIds: _.get(
                      getState(),
                      "tooling.filters.multiAccessIdentities.tagIds",
                      []
                    ),
                    orderBy: "EMAIL",
                  },
                },
              },
            ];
          }

          return refetchQuery ? [refetchQuery] : [];
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );
      setIsLoading(false);

      return _.get(
        response,
        "data.platform.bulkRemoveUsersFromMultiAccessIdentity",
        {}
      );
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const editMultiAccessIdentity = ({
  variables = {},
  feedFilters,
  setIsLoading,
}) => {
  return async (dispatch, getState) => {
    try {
      setIsLoading(true);

      await client.mutate({
        mutation: editMultiAccessIdentityMutation,
        variables: {
          input: {
            ...variables,
          },
        },
        refetchQueries: [
          {
            query: getMultiAccessIdentityFeedQuery,
            variables: {
              filters: feedFilters,
            },
          },
        ],
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );
      setIsLoading(false);
    } catch (error) {
      console.error(error);

      setIsLoading(false);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const removeUserFromMultiAccessIdentity = ({
  userId,
  identityId,
  setIsLoading,
  feedFilters,
}) => {
  return async (dispatch, getState) => {
    try {
      setIsLoading(true);
      await client.mutate({
        mutation: removeUserFromMultiAccessIdentityMutation,
        variables: {
          input: {
            userId,
            identityId,
          },
        },
        refetchQueries: [
          {
            query: getManageLinkedUsersFeedQuery,
            variables: feedFilters,
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);

      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const removeUserFromMultiAccessIdentityV2 = ({ userId, identityId }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: removeUserFromMultiAccessIdentityMutation,
        variables: {
          input: {
            userId,
            identityId,
          },
        },
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (error) {
      console.error(error);

      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const addUsersToMultiAccessIdentity = ({
  identityId,
  organizations,
  users,
  feedFilters,
  setIsLoading,
}) => {
  return async dispatch => {
    try {
      setIsLoading(true);

      await client.mutate({
        mutation: addUsersToMultiAccessIdentityMutation,
        variables: {
          input: {
            identityId,
            organizations,
            users,
          },
        },
        refetchQueries: [
          {
            query: getManageLinkedUsersFeedQuery,
            variables: feedFilters,
          },
        ],
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );

      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);

      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const downloadConfigurationDML = ({
  configurationId,
  configuration,
  setIsLoading,
}) => {
  return async dispatch => {
    try {
      setIsLoading(true);
      const response = await client.query({
        query: generateConfigurationDMLQuery,
        variables: {
          configurationId,
        },
        fetchPolicy: "network-only",
      });
      const DML = _.get(
        response,
        "data.platform.generateConfigurationPortDML.DML"
      );
      const fileName = `${configuration}_DML.sql`;
      const buffer = new Blob([DML], { type: "text/plain" });
      FileSaver.saveAs(buffer, fileName);

      dispatch(
        setToastMsg({
          type: "success",
          msg: "Downloaded Successfully",
          notString: true,
        })
      );
    } catch (e) {
      const mutationError = _.get(e, ["graphQLErrors", 0, "message"]);
      dispatchError({
        dispatch,
        customMessage: mutationError,
        e,
        notString: mutationError,
      });
    } finally {
      setIsLoading(false);
    }
  };
};

export const fetchConfigurationDML = ({ configurationId, setIsLoading }) => {
  return async dispatch => {
    try {
      setIsLoading(true);
      const response = await client.query({
        query: generateConfigurationDMLQuery,
        variables: {
          configurationId,
        },
        fetchPolicy: "network-only",
      });
      return _.get(response, "data.platform.generateConfigurationPortDML.DML");
    } catch (e) {
      const mutationError = _.get(e, ["graphQLErrors", 0, "message"]);
      dispatchError({
        dispatch,
        customMessage: mutationError,
        e,
        notString: mutationError,
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  };
};

const getLocaleParams = portType => {
  switch (portType) {
    case "ADD_NEW_TEMPLATE_TO_ORGANIZATION":
      return [
        { key: "label", value: "Template id", isPlainText: true },
        { key: "action", value: "added", isPlainText: true },
      ];
    case "UPDATE_EXISTING_TEMPLATE":
      return [
        { key: "label", value: "Template id", isPlainText: true },
        { key: "action", value: "updated", isPlainText: true },
      ];
    case "REMOVE_TEMPLATE_FROM_ORGANIZATION":
      return [
        { key: "label", value: "Template id", isPlainText: true },
        { key: "action", value: "removed", isPlainText: true },
      ];
    case "ADD_HELP_TEXT":
      return [
        { key: "label", value: "Help Text", isPlainText: true },
        { key: "action", value: "added", isPlainText: true },
      ];
    default:
      return [
        { key: "label", value: "Entity", isPlainText: true },
        { key: "action", value: "Created", isPlainText: true },
      ];
  }
};

const getConfigurationsInput = ({ configurationDetails }) => {
  const relationshipData = _.map(
    configurationDetails.relationshipData,
    (relationship, configurationId) => ({
      configurationId,
      relationType: relationship.value,
    })
  );
  return _.omit({ ...configurationDetails, relationshipData }, [
    "configurationView",
    "removedItems",
  ]);
};

const getEntitiesData = ({ list }) =>
  _.filter(list, group => {
    const entityGroupId = _.get(_.head(group), "entityGroupId");
    return _.isEmpty(entityGroupId);
  });

const getConfigurationEditInput = ({ configurations, configurationId }) => {
  const { configurationDetails } = configurations;
  const { removedItems } = configurationDetails;

  const relationshipData = _.reduce(
    configurationDetails.relationshipData,
    (result, { value }, key) => {
      result.push({
        configurationId: key,
        relationType: value,
      });
      return result;
    },
    []
  );
  const validityData = getEntitiesData({
    list: configurationDetails.validityData,
  });
  const lockData = getEntitiesData({ list: configurationDetails.lockData });
  return _.omit(
    {
      ...configurationDetails,
      configurationId,
      relationshipData,
      validityData,
      lockData,
      removedData: {
        validityRemovedGroups: removedItems.validityData,
        lockRemovedGroups: removedItems.lockData,
      },
    },
    ["configurationView", "removedItems", "id", "__typename"]
  );
};

export const excuteInternalToolsGenericApi = input => {
  return async (dispatch, getState) => {
    let data = null;
    let rowsCount = null;
    try {
      const response = await client.mutate({
        mutation: internalToolsGenericMutation,
        variables: input,
      });
      const warning = _.get(
        response,
        "data.platform.internalToolsGenericMutation.warning"
      );
      data = _.get(response, "data.platform.internalToolsGenericMutation.data");
      // const isSuccess = _.get(
      //   response,
      //   "data.platform.internalToolsGenericMutation.isSuccess"
      // );
      rowsCount = _.get(data, "rowsAffected", null);

      if (rowsCount) {
        setTimeout(() => {
          dispatch(
            setToastMsg({ type: "success", msg: rowsCount, notString: true })
          );
        }, 2000);
      }
      if (_.isEmpty(warning)) {
        dispatch(
          setToastMsg({
            type: "success",
            msg: "toastMsgs:action_successfully",
            locale_params: getLocaleParams(input.params.portType),
          })
        );
      } else {
        console.error(warning);
        dispatch(setToastMsg({ msg: warning.message, notString: true }));
      }
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
    if (_.get(data, "failIds", null)) return data;
  };
};

// delete and deprecate state configuration
export const toggleConfigurationState = ({
  id,
  stateToToggle,
  restoreState,
}) => {
  return async (dispatch, getState) => {
    try {
      const searchText = getState().tooling.searchString.configurations;
      const sortedFieldsWithOrder = getState().tooling.configurations
        .sortFields;
      const feedFilters = getState().tooling.filters.configurations;
      const filters = getConfigurationsFilters({
        searchText,
        sortedFieldsWithOrder,
        feedFilters,
      });
      await client.mutate({
        mutation: toggleConfigurationStateMutation,
        variables: { input: { id, stateToToggle } },
        refetchQueries: [
          {
            query: getGenericConfigurationsFeedQuery,
            variables: { filters },
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: getToastMsg(stateToToggle, restoreState),
          notString: true,
        })
      );
    } catch (e) {
      dispatchError({ dispatch, e });
    }
  };
};

// create configuration mutation
export const createGenericConfiguration = () => {
  return async (dispatch, getState) => {
    try {
      const searchText = getState().tooling.searchString.configurations;
      const sortedFieldsWithOrder = getState().tooling.configurations
        .sortFields;
      const feedFilters = getState().tooling.filters.configurations;
      const filters = getConfigurationsFilters({
        searchText,
        sortedFieldsWithOrder,
        feedFilters,
      });
      const configurationDetails = getState().tooling.configurations
        .configurationDetails;
      const input = getConfigurationsInput({ configurationDetails });
      await client.mutate({
        mutation: createGenericConfigurationMutation,
        variables: { input },
        refetchQueries: [
          {
            query: getGenericConfigurationsFeedQuery,
            variables: { filters },
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "Added configuration successfully",
          notString: true,
        })
      );
    } catch (e) {
      const mutationError = _.get(e, ["graphQLErrors", 0, "message"]);
      dispatchError({
        dispatch,
        customMessage: mutationError,
        e,
        notString: mutationError,
      });
      throw e;
    }
  };
};

// edit configuration mutation
export const editGenericConfiguration = ({ configurationId }) => {
  return async (dispatch, getState) => {
    try {
      const configurations = getState().tooling.configurations;
      const input = getConfigurationEditInput({
        configurations,
        configurationId,
      });
      const searchText = getState().tooling.searchString.configurations;
      const sortedFieldsWithOrder = getState().tooling.configurations
        .sortFields;
      const feedFilters = getState().tooling.filters.configurations;
      const filters = getConfigurationsFilters({
        searchText,
        sortedFieldsWithOrder,
        feedFilters,
      });
      await client.mutate({
        mutation: editGenericConfigurationMutation,
        variables: { input },
        refetchQueries: [
          {
            query: getConfigurationDetailsQuery,
            variables: { id: configurationId },
          },
          {
            query: getGenericConfigurationsFeedQuery,
            variables: { filters },
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "Configuration updated successfully",
          notString: true,
        })
      );
      return true;
    } catch (e) {
      const mutationError = _.get(e, ["graphQLErrors", 0, "message"]);
      dispatchError({
        dispatch,
        customMessage: mutationError,
        e,
        notString: mutationError,
      });
      throw e;
    }
  };
};

// add configuration value mutation
export const addConfigurationValues = ({
  configurationId,
  valueType,
  isNewConfigurationFlowEnabled,
}) => {
  return async (dispatch, getState) => {
    try {
      const {
        entityGroups,
        settingValue,
        region,
      } = getState().tooling.configurations.addValueDetails;

      const input = {
        id: configurationId,
        valueType,
        value: settingValue,
        entityGroups: _.map(entityGroups, item => item?.entityGroup),
      };
      if (isNewConfigurationFlowEnabled) {
        await client.mutate({
          mutation: addConfigurationValuesMutationV2,
          variables: { input: { ...input, regionId: region } },
        });
      } else {
        await client.mutate({
          mutation: addConfigurationValuesMutationV1,
          variables: { input },
        });
      }
      dispatch(
        setToastMsg({
          type: "success",
          msg: "Configuration value added successfully",
          notString: true,
        })
      );
      return true;
    } catch (e) {
      const mutationError = _.get(e, ["graphQLErrors", 0, "message"]);
      dispatchError({
        dispatch,
        customMessage: mutationError,
        e,
        notString: mutationError,
      });
      return false;
    }
  };
};

// upsert configuration view mutation
export const upsertConfigurationView = ({ configurationId }) => {
  return async (dispatch, getState) => {
    try {
      const configurationView = getState().tooling.configurations
        .configurationDetails.configurationView;
      const { platform, view, id } = configurationView;
      const input = {
        platform,
        view: _.omit(view, ["__typename"]),
        viewId: id,
        id: configurationId,
      };
      await client.mutate({
        mutation: upsertConfigurationViewMutation,
        variables: { input },
        refetchQueries: [
          {
            query: getConfigurationDetailsQuery,
            variables: { id: configurationId },
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "Added configuration successfully",
          notString: true,
        })
      );
    } catch (e) {
      dispatchError({ dispatch, e });
    }
  };
};

export const validateInternalToolsModulePassword = params => {
  return async (dispatch, getState) => {
    dispatch(setIsLoading({ isLoadingPasswordState: true }));
    let isPasswordValid = false;
    try {
      const response = await client.mutate({
        mutation: validateInternalToolsModulePasswordMutation,
        variables: params,
      });
      isPasswordValid = _.get(
        response,
        "data.platform.validateInternalToolsModulePassword",
        false
      );
      if (!isPasswordValid) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:password_is_invalid",
            type: "warning",
            position: "toast-bottom-left",
          })
        );
      }
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg({ msg: e.message, notString: true }));
    } finally {
      dispatch(setIsLoading({ isLoadingPasswordState: false }));
      dispatch(
        setIsPasswordValid({ type: params.input.type, isPasswordValid })
      );
    }
    return isPasswordValid;
  };
};

export const createOrganization = orgDetails => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: createOrganizationV2Mutation,
        variables: { input: orgDetails },
      });
      const { isSuccess, warning } = _.get(
        res,
        "data.platform.createOrganizationV2",
        {}
      );

      const organization = _.get(
        res,
        "data.platform.createOrganizationV2.organization"
      );

      if (!isSuccess) {
        const message = _.get(warning, "message", "");
        throw new Error(message);
      }

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:action_successfully",
          locale_params: [
            { key: "label", value: "School", isPlainText: true },
            { key: "action", value: "toastMsgs:created", isPlainText: false },
          ],
        })
      );
      return { organization, isSuccess };
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const updateCurriculumPrograms = ({
  curriculumOptions,
  id,
  examSessionMonth,
  timezone,
  showToastMsg = true,
}) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: updateCurriculumProgramsMutation,
        variables: {
          input: {
            id,
            curriculumOptions,
            examSessionMonth,
            timezone,
          },
        },
      });

      const { isSuccess, warning } = _.get(
        response,
        "data.platform.updateOrganizationV2",
        {}
      );

      let updatedOrganizationDetails = {};

      if (isSuccess) {
        updatedOrganizationDetails = _.get(
          response,
          "data.platform.updateOrganizationV2.organization",
          []
        );
        if (showToastMsg) {
          dispatch(
            setToastMsg({
              type: "success",
              msg: "toastMsgs:saved_successfully",
            })
          );
        }
      } else {
        const code = _.get(_.head(warning), "code", "");
        throw new Error(ERROR_CODE_TO_MSG_MAPPING[code]);
      }
      return { isSuccess, updatedOrganizationDetails };
    } catch (e) {
      dispatchError({
        dispatch,
        e,
        customMessage: !e.networkError ? _.get(e, "message") : null,
      });
      throw e;
    }
  };
};

export const updateOrganizationBasicDetails = ({
  id,
  name,
  code,
  addedAttachments,
  removedAttachments,
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateOrganizationBasicDetailsMutation,
        variables: {
          id,
          name,
          code,
          addedAttachments,
          removedAttachments,
        },
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:saved_successfully",
        })
      );
    } catch (e) {
      dispatchError({ dispatch, e });
      throw e;
    }
  };
};

export const updateOrganizationPaidStatus = ({ input, queryVariables }) => {
  return async dispatch => {
    const isManageProgrammesRoute = _.includes(
      getCurrentPathname(),
      "managePrograms"
    );

    try {
      await client.mutate({
        mutation: updateOrganizationPaidStatusMutation,
        variables: input,
        update: cache => {
          cache.updateQuery(
            {
              query: isManageProgrammesRoute
                ? getOrganizationFeedQueryForProgrammes
                : getOrganizationFeedQuery,
              variables: queryVariables,
            },
            cachedData => {
              if (!cachedData) return null;
              const updatedEdges = cachedData.platform.organizationFeed.edges.map(
                edge => {
                  if (edge.node.id === input.organizationId) {
                    return {
                      ...edge,
                      node: {
                        ...edge.node,
                        isPaid: input.isPaid,
                      },
                    };
                  }
                  return edge;
                }
              );
              return {
                ...cachedData,
                platform: {
                  ...cachedData.platform,
                  organizationFeed: {
                    ...cachedData.platform.organizationFeed,
                    edges: updatedEdges,
                  },
                },
              };
            }
          );
        },
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:saved_successfully",
        })
      );
    } catch (e) {
      const mutationError = _.get(e, ["graphQLErrors", 0, "message"]);
      dispatchError({
        dispatch,
        customMessage: mutationError,
        e,
        notString: mutationError,
      });
      throw e;
    }
  };
};

export const updateOrganizationAcademicYear = academicYear => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: updateOrganizationAcademicYearMutation,
        variables: academicYear,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getAcademicYears,
            variables: {
              id: academicYear.orgId,
            },
          },
        ],
      });

      const warning = _.get(
        response,
        "data.organizationManagement.manageOrganizationAcademicYear.warning"
      );
      const data = _.get(
        response,
        "data.organizationManagement.manageOrganizationAcademicYear.response"
      );
      if (_.isEmpty(warning)) {
        dispatch(
          setToastMsg({
            type: "success",
            msg: "toastMsgs:saved_successfully",
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:academic_years_clash",
          })
        );
      }
      return data;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const createOrganizationAcademicYear = academicYear => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: createOrganizationAcademicYearMutation,
        variables: academicYear,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getAcademicYears,
            variables: {
              id: academicYear.id,
            },
          },
        ],
      });

      const warning = _.get(
        response,
        "data.organizationManagement.manageOrganizationAcademicYear.warning"
      );
      const data = _.get(
        response,
        "data.organizationManagement.manageOrganizationAcademicYear.response"
      );
      if (_.isEmpty(warning)) {
        dispatch(
          setToastMsg({
            type: "success",
            msg: "toastMsgs:saved_successfully",
          })
        );
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:academic_years_clash",
          })
        );
      }
      return data;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const bulkDownloadOrganizationData = ({ filters }) => {
  return async (dispatch, getState) => {
    try {
      const queryData = await client.query({
        query: bulkDownloadOrganizationDataQuery,
        variables: { filters },
        fetchPolicy: "network-only",
      });

      const data = _.get(
        queryData,
        "data.platform.bulkDownloadOrganizationData",
        {}
      );

      return data;
    } catch (error) {
      throw error;
    }
  };
};

export const bulkUpload = ({ url, type, organizationId, inputs }) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: bulkUploadByFileMutation,
        variables: {
          url,
          type,
          organizationId,
          inputs,
        },
      });
      const bulkUploadFileData = _.get(
        response,
        "data.platform.bulkUploadByFile",
        undefined
      );

      const responseSuccessful = _.get(bulkUploadFileData, "successful", false);

      let returnObject = {
        type: "success",
        msg: "toastMsgs:successfully_with_label",
        locale_params: [
          { key: "label", value: "toastMsgs:added", isPlainText: false },
        ],
      };
      if (!responseSuccessful) {
        returnObject = "toastMsgs:couldnt_be_added";
      }

      dispatch(setToastMsg(returnObject));

      return bulkUploadFileData;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {
        successful: false,
        errors: ["Something went wrong"],
      };
    }
  };
};

export const createOrganizationPreset = orgDetails => {
  return async (dispatch, getState) => {
    // let params = {};
    // params["createCourse"] = true;
    // let courseDetails = getState().createCourse.courseDetails;
    // let communModule = getState().adminCommon.selectedList;
    // let studentsToAdd = getState().adminCommon.selectedList.students.map(
    //   student => student.node.id
    // );
    // let collaboratorsAddWithId = getState().adminCommon.selectedList.teachers.map(
    //   teacher => teacher.node.id
    // );
    // dispatch(updateLoading(params));
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: true }));
    try {
      await client.mutate({
        mutation: createOrganizationPresetMutation,
        variables: orgDetails,
        refetchQueries: [
          {
            query: getAllOrganizationQuery,
            variables: {
              searchText: getState().tooling.searchString.orgnizationManagement,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:school_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:created", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:create", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }

    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: false }));
  };
};

export const updateOrganizationPreset = orgDetails => {
  return async (dispatch, getState) => {
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: true }));
    try {
      await client.mutate({
        mutation: updateOrganizationPresetMutation,
        variables: orgDetails,
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:school_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:updated", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:update", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: false }));
  };
};

export const deleteOrganizationPreset = orgDetails => {
  return async (dispatch, getState) => {
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: true }));
    try {
      await client.mutate({
        mutation: deleteOrganizationPresetMutation,
        variables: orgDetails,
        refetchQueries: [
          {
            query: getAllOrganizationQuery,
            variables: {
              searchText: getState().tooling.searchString.orgnizationManagement,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:school_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:deleted", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:delete", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: false }));
  };
};

export const approveOrganization = orgDetails => {
  return async (dispatch, getState) => {
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: true }));
    try {
      await client.mutate({
        mutation: approveOrganizationMutation,
        variables: orgDetails,
        refetchQueries: [
          {
            query: getOrganizationApprovalRequestFeed,
            variables: {
              searchText: getState().tooling.searchString.organizationApproval,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:school_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:approved", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:approve", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: false }));
  };
};

export const deleteApproveSchoolRequest = orgDetails => {
  return async (dispatch, getState) => {
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: true }));
    try {
      await client.mutate({
        mutation: deleteApproveSchoolRequestMutation,
        variables: orgDetails,
        refetchQueries: [
          {
            query: getOrganizationApprovalRequestFeed,
            variables: {
              searchText: getState().tooling.searchString.organizationApproval,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:school_request_rejected",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:delete", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: false }));
  };
};

export const deleteConfigurationValue = ({
  ids,
  isDeleted,
  configurationValuesQueryVariables,
}) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: deleteConfigurationValueMutation,
        variables: { ids, isDeleted },
        refetchQueries: [
          {
            query: getConfigurationValuesQuery,
            variables: configurationValuesQueryVariables,
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          position: "toast-bottom-left",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:deleted", isPlainText: false },
          ],
        })
      );
    } catch (err) {
      dispatchError({ dispatch, err });
    }
  };
};

export const updateConfigurationEntityValue = ({
  input,
  configurationValuesQueryVariables,
}) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateConfigurationEntityValueMutation,
        variables: { input },
        refetchQueries: [
          {
            query: getConfigurationValuesQuery,
            variables: configurationValuesQueryVariables,
          },
        ],
      });
      dispatch(
        setToastMsg({
          type: "success",
          position: "toast-bottom-left",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:updated", isPlainText: false },
          ],
        })
      );
    } catch (err) {
      dispatchError({ dispatch, err });
    }
  };
};

//approveUserMutation
export const approveUser = userDetails => {
  return async (dispatch, getState) => {
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: true }));
    try {
      const userId = userDetails.id;
      const orgId = _.get(userDetails, "organizationPreset.id", "");
      await client.mutate({
        mutation: approveUserMutation,
        variables: { presetOrgId: orgId, unauthenticatedUserId: userId },
        refetchQueries: [
          {
            query: getUserApprovalRequestFeed,
            variables: {
              searchText: getState().tooling.searchString.organizationApproval,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:user_approved",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:approve", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: false }));
  };
};

export const deleteApproveUser = userDetails => {
  return async (dispatch, getState) => {
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: true }));
    try {
      await client.mutate({
        mutation: deleteApproveUserRequestMutation,
        variables: userDetails,
        refetchQueries: [
          {
            query: getUserApprovalRequestFeed,
            variables: {
              searchText: getState().tooling.searchString.organizationApproval,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:user_rejected",
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:delete", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }
    dispatch(setIsLoadingState({ key: "orgnizationManagement", value: false }));
  };
};

// User Feed

export const updateStandardInfo = params => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: editStandardInfoMutation,
        variables: params,
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:saved_successfully",
        })
      );
      return true;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const deleteOrganization = params => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: deleteOrganizationMutation,
        variables: params.variables,
      });
      dispatch(
        setToastMsg({
          msg: params.isAccessManagerV2
            ? "toastMsgs:account_successfully_action"
            : "toastMsgs:school_successfully_action",
          locale_params: [
            { key: "action", value: "toastMsgs:deleted", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:deleted", isPlainText: false },
          ],
        })
      );
      dispatch(
        setIsLoadingState({ key: "orgnizationManagement", value: false })
      );
      throw err;
    }
  };
};
export const deleteStandard = params => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: deleteStandardMutation,
        variables: params,
        refetchQueries: [
          {
            query: getStandardFeedQuery,
            variables: {
              filters: {
                searchText: getState().tooling.searchString.standards,
                subjects: getState().tooling.filters.standards.subjectFilters,
                curriculumTypes: getState().tooling.filters.standards
                  .curriculumTypeFilters,
              },
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:item_successfully_removed_from",
          locale_params: [
            { key: "fromItem", value: "Standard", isPlainText: true },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:failed_to_action",
          locale_params: [
            { key: "action", value: "toastMsgs:delete", isPlainText: false },
          ],
        })
      );
      // dispatch(
      //   setIsLoadingState({ key: "standards", value: false })
      // );
      throw err;
    }
  };
};
export const updateConfigurablePermissions = params => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: updateConfigurablePermissionMutation,
        variables: params,
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:saved_successfully",
        })
      );
      return true;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const deleteUserIdentityAccessManager = ({
  variables = {},
  setIsLoading,
  feedFilters,
}) => {
  return async dispatch => {
    try {
      setIsLoading(true);
      const response = await client.mutate({
        mutation: removeUserIdentityFromMultiAccessIdentityMutation,
        variables: {
          input: variables,
        },
        refetchQueries: [
          {
            query: getMultiAccessIdentityFeedQuery,
            variables: {
              filters: feedFilters,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:saved_successfully",
          type: "success",
          position: "toast-bottom-left",
        })
      );
      setIsLoading(false);
      return _.get(
        response,
        "data.platform.removeUserIdentityFromMultiAccessIdentity",
        {}
      );
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const enableBulkConfigurationsForOrgs = ({
  variables,
  setIsLoading,
}) => {
  return async (dispatch, getState) => {
    try {
      setIsLoading(true);
      await client.mutate({
        mutation: configurationMultiValueUpsertMutation,
        variables,
      });
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

export const configurationCacheFlush = ({ variables, setIsLoading }) => {
  return async (dispatch, getState) => {
    try {
      setIsLoading(true);
      await client.mutate({
        mutation: configurationCacheFlushMutation,
        variables,
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:saved_successfully",
        })
      );
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createOrganizationAccessRequestForUser = ({
  managerIdentityId,
  organizations,
  requestFilters,
  isSupportUserAccess = false,
}) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createOrganizationAccessRequestForUserMutation,
        variables: {
          input: {
            managerIdentityId,
            organizations,
            isSupportUserAccess,
          },
        },
        refetchQueries: [
          {
            query: isSupportUserAccess
              ? getOrganizationUserAccessRequestQuery
              : getOrganizationPermissionRequestQuery,
            variables: {
              filters: requestFilters,
            },
          },
        ],
      });
      const { isSuccess, warning } = _.get(
        response,
        "data.platform.addRequestForUsersMultiAccessIdentity",
        {}
      );
      if (!isSuccess) {
        throw new Error(warning);
      }
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:request_sent",
        })
      );
    } catch (error) {
      console.error(error);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createMultiAccessIdentityUserAccessRequest = ({
  managerIdentityId,
  users,
  requestFilters,
}) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createMultiAccessIdentityUserAccessRequestMutation,
        variables: {
          input: {
            managerIdentityId,
            users,
          },
        },
        refetchQueries: [
          {
            query: getOrganizationUserAccessRequestQuery,
            variables: {
              filters: requestFilters,
            },
          },
        ],
      });
      const { isSuccess, warning } = _.get(
        response,
        "data.platform.addRequestForMultiAccessIdentityUserAccess",
        {}
      );
      if (!isSuccess) {
        const code = _.get(warning, "code", "");
        const errMsg = _.get(
          ERROR_CODE_TO_MSG_MAPPING,
          code,
          "toastMsgs:something_went_wrong"
        );
        throw new Error(errMsg);
      }
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:request_sent",
        })
      );
    } catch (e) {
      console.error(e);
      dispatchError({
        dispatch,
        e,
        customMessage: !e.networkError ? _.get(e, "message") : null,
      });
    }
  };
};

export const editRequestForOrganizationAccess = ({
  requestIds,
  excludedRequestIds,
  selectAllFilters,
  status,
  requestFilters,
}) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: editRequestForOrganizationAccessMutation,
        variables: {
          input: {
            requestIds,
            status,
            excludedRequestIds,
            selectAllFilters,
          },
        },
        refetchQueries: [
          {
            query: getOrganizationPermissionRequestQuery,
            variables: {
              filters: requestFilters,
            },
          },
        ],
      });
      const { isSuccess, warning } = _.get(
        response,
        "data.platform.editRequestForMultiAccessIdentity",
        {}
      );
      if (!isSuccess) {
        throw new Error(warning);
      }
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:updated",
        })
      );
    } catch (error) {
      console.error(error);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const editRequestForUserAccess = ({
  requestIds,
  excludedRequestIds,
  selectAllFilters,
  status,
  requestFilters,
}) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: editRequestForUserAccessMutation,
        variables: {
          input: {
            requestIds,
            status,
            excludedRequestIds,
            selectAllFilters,
          },
        },
        refetchQueries: [
          {
            query: getOrganizationUserAccessRequestQuery,
            variables: {
              filters: requestFilters,
            },
          },
        ],
      });
      const { isSuccess, warning } = _.get(
        response,
        "data.platform.editRequestForMultiAccessIdentityUserAccess",
        {}
      );
      if (!isSuccess) {
        throw new Error(warning);
      }
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:updated",
        })
      );
    } catch (error) {
      console.error(error);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteMultiAccessIdentityRequest = ({
  requestIds,
  requestFilters,
}) => {
  return async dispatch => {
    const response = await client.mutate({
      mutation: deleteMultiAccessIdentityRequestMutation,
      variables: {
        input: { requestIds },
      },
      refetchQueries: [
        {
          query: getOrganizationUserAccessRequestQuery,
          variables: {
            filters: requestFilters,
          },
        },
      ],
    });
    const { isSuccess, warning } = _.get(
      response,
      "data.platform.deleteRequestForMultiAccessIdentityUserAccess",
      {}
    );
    if (!isSuccess) {
      throw new Error(warning);
    }
    dispatch(
      setToastMsg({
        type: "success",
        msg: "Request deleted successfully!",
      })
    );
  };
};

export const editSchoolCloudStorageAccount = ({ id, value }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: editSchoolCloudStorageAccountMutation,
        variables: {
          input: {
            id,
            organizationConstants: [
              {
                name: "THIRD_PARTY_SERVICE_TYPE_PREFERENCE",
                value,
              },
            ],
          },
        },
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:cloud_storage_updated_successfully",
        })
      );
    } catch (e) {
      dispatchError({ dispatch, e });
      throw e;
    }
  };
};

export const getSelectedRegions = ({ regionIds }) => {
  const selectedRegions = _.filter(REGION_FILTER_OPTIONS, region =>
    _.includes(regionIds, region.value)
  );
  const regionLabels = _.map(selectedRegions, region => region.label);
  if (regionLabels.length === 0) {
    return "";
  }
  if (regionLabels.length === REGION_FILTER_OPTIONS.length) {
    return "All";
  }
  return _.join(regionLabels, ", ");
};

//This Function is used to check if academic years are valid
//It just checks if any academic years are over lapping with each other or not
export const checkAcademicYears = ({ academicYears }) => {
  const updatedAcademicYears = _.map(academicYears, academicYear => {
    return {
      startDate: moment(academicYear?.dateDurationValue?.startDate).format(
        "YYYY-MM-DD"
      ),
      endDate: moment(academicYear?.dateDurationValue?.endDate).format(
        "YYYY-MM-DD"
      ),
    };
  });

  const sortedAcademicYears = _.sortBy(updatedAcademicYears, "startDate");

  //This is true if any Dates are over lapped
  const isOverlapped = _.some(
    sortedAcademicYears,
    (item, index) =>
      index > 0 &&
      moment(item.startDate).isBefore(sortedAcademicYears[index - 1]?.endDate)
  );

  const areDatedValid = !isOverlapped;
  return areDatedValid;
};

//This function is used to check if 3 academic years are created
// 1 Prev, 1 Current, 1 Next while creating the DP Org
export const checkDPAcademicYears = ({ academicYears }) => {
  if (_.size(academicYears) < 3) {
    return false;
  }

  const now = new Date();

  const currentYear = _.find(
    academicYears,
    academicYear =>
      moment(academicYear?.startDate).isBefore(now) &&
      moment(academicYear?.endDate).isAfter(now)
  );

  const prevYear = _.find(academicYears, academicYear =>
    moment(academicYear?.endDate).isBefore(currentYear?.startDate)
  );
  const nextYear = _.find(academicYears, academicYear =>
    moment(academicYear?.startDate).isAfter(currentYear?.endDate)
  );

  if (!currentYear || !prevYear || !nextYear) {
    return false;
  }

  return true;
};

export const getDefaultAcademicYears = () => {
  const currentAYStartDate = moment().format("YYYY-MM-DD");
  const currentAYEndDate = moment(currentAYStartDate)
    .add(1, "years")
    .subtract(1, "days")
    .format("YYYY-MM-DD");

  const prevAYEndDate = moment(currentAYStartDate)
    .subtract(1, "days")
    .format("YYYY-MM-DD");

  const prevAYStartDate = moment(prevAYEndDate)
    .subtract(1, "years")
    .add(1, "days")
    .format("YYYY-MM-DD");

  const nextAYStartDate = moment(currentAYEndDate)
    .add(1, "days")
    .format("YYYY-MM-DD");

  const nextAYEndDate = moment(nextAYStartDate)
    .add(1, "years")
    .subtract(1, "days")
    .format("YYYY-MM-DD");

  const academicYears = [
    {
      id: generateRandomId(),
      dateDurationValue: {
        startDate: prevAYStartDate,
        endDate: prevAYEndDate,
      },
    },
    {
      id: generateRandomId(),
      isCurrentAcademicYear: true,
      dateDurationValue: {
        startDate: currentAYStartDate,
        endDate: currentAYEndDate,
      },
    },
    {
      id: generateRandomId(),
      dateDurationValue: {
        startDate: nextAYStartDate,
        endDate: nextAYEndDate,
      },
    },
  ];

  return academicYears;
};

export const transformAcademicYears = ({ academicYears }) => {
  return _.map(
    academicYears,

    ({ id, isCurrentAcademicYear, startDate, endDate }) => {
      return {
        id,
        isCurrentAcademicYear,
        dateDurationValue: {
          startDate: moment(startDate).format("YYYY-MM-DD"),
          endDate: moment(endDate).format("YYYY-MM-DD"),
        },
      };
    }
  );
};
export const getValidAdminsPayload = ({ admins }) => {
  return _.reduce(
    admins,
    (result, admin) => {
      const { firstName, lastName, email } = admin;
      const isAdminDataPresent =
        _.trim(firstName) || _.trim(lastName) || _.trim(email);
      if (isAdminDataPresent) {
        return [...result, { firstName, lastName, email }];
      }
      return result;
    },
    []
  );
};

export const fetchAllClassesOfOrg = params => {
  return async (dispatch, getState) => {
    try {
      const result = await client.query({
        query: fetchAllClassesOfOrgQuery,
        variables: params,
        fetchPolicy: "network-only",
      });
      return _.get(result, "data.node.courses.edges", false);
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:invalid_org_id"));
    }
  };
};

export const createSurveyRuleset = surveyRulesetDetails => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: createSurveyRulesetMutation,
        variables: { input: surveyRulesetDetails },
        refetchQueries: [
          {
            query: getRuleSetFeedQuery,
          },
        ],
      });
      const { isSuccess, warning } = _.get(
        res,
        "data.platform.createSurveyRuleset",
        {}
      );
      if (!isSuccess) {
        const message = _.get(warning, "message", "");
        throw new Error(message);
      }

      dispatch(
        setToastMsg({
          type: "success",
          msg: "Ruleset created successfully",
          locale_params: [
            {
              isPlainText: true,
            },
          ],
        })
      );
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createCompleteSurvey = surveyDetails => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: createCompleteSurveyMutation,
        variables: { input: surveyDetails },
        refetchQueries: [
          {
            query: getSurveyFeedQuery,
          },
        ],
      });
      const { isSuccess, warning } = _.get(
        res,
        "data.platform.createCompleteSurvey",
        {}
      );
      if (!isSuccess) {
        const message = _.get(warning, "message", "");
        throw new Error(message);
      }

      dispatch(
        setToastMsg({
          type: "success",
          msg: "Survey created successfully",
          locale_params: [
            {
              isPlainText: true,
            },
          ],
        })
      );
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const setIsPasswordValid = dispatch => {
  return {
    type: SET_IS_PASSWORD_VAILD,
    data: dispatch,
  };
};
export const setIsLoading = dispatch => {
  return {
    type: SET_IS_LOADING,
    data: dispatch,
  };
};

const REDUCER_HANDLERS = {
  [CHANGE_ORGANIZATION_SEARCH_STRING]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        searchString: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [CHANGE_USER_SEARCH_STRING]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        searchString: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [CHANGE_STANDARD_SEARCH_STRING]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        searchString: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [SET_IS_LOADING_STATE]: (state, action) => {
    const key = action.payload.key;
    const value = action.payload.value;

    return update(state, {
      isLoading: { [key]: { $set: value } },
    });
  },
  [CHANGE_RULESET_SEARCH_STRING]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        searchString: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  //User Feed
  [TOGGLE_TEACHER_TABS]: (state, action) => {
    return update(state, { teacherTab: { $set: action.payload } });
  },
  [INIT_REMOVED_COURSES]: (state, action) => {
    return update(state, {
      removedCourses: { $set: initialState.removedCourses },
    });
  },

  [TOGGLE_REMOVED_COURSES]: (state, action) => {
    const data = action.payload;
    const operation = data.operation;
    const value = data.value;
    const itemIndex = data.index;
    if (operation == "add") {
      state = update(state, { removedCourses: { $push: [value] } });
    } else {
      state = update(state, { removedCourses: { $splice: [[itemIndex, 1]] } });
    }
    return state;
  },
  [CHANGE_SEARCH_TERM]: (state, action) => {
    return update(state, { searchText: { $set: action.payload } });
  },
  [INIT_SEARCH_TERM]: (state, action) => {
    return update(state, { searchText: { $set: initialState.searchText } });
  },
  [UPDATE_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        filters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_TEACHER_OBJECT]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        teacherDetails: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [INIT_TEACHER_OBJECT]: (state, action) => {
    return update(state, {
      teacherDetails: { $set: initialState.teacherDetails },
    });
  },
  [UPDATE_TEACHER_STEP]: (state, action) => {
    return update(state, { teacherStep: { $set: action.payload } });
  },
  [TOGGLE_MANAGE_COURSE_ROUTE]: (state, action) => {
    return update(state, { manageCourseRoute: { $set: action.data } });
  },
  [TOGGLE_ACTION_LOADING]: (state, action) => {
    return update(state, {
      isActionLoading: { $set: action.data },
    });
  },
  [UPDATE_ORGANIZATION_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        organizationFilters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [SET_IS_PASSWORD_VAILD]: (state, action) => {
    const { isPasswordValid, type } = action.data;
    state = update(state, {
      ["passwordValidityStatus"]: {
        [type]: { $set: isPasswordValid },
      },
    });
    return state;
  },
  [SET_IS_LOADING]: (state, action) => {
    const { isLoadingPasswordState } = action.data;
    state = update(state, {
      ["isLoadingPasswordState"]: { $set: isLoadingPasswordState },
    });
    return state;
  },
  [UPDATE_CONFIGURATION_SORT_ORDER]: (state, action) => {
    const { id, menuItemEntity, sortDirection } = action.payload;
    return update(state, {
      configurations: {
        sortFields: {
          $set: { [id]: { direction: sortDirection, menuItemEntity } },
        },
      },
    });
  },
  [UPDATE_CONFIGURATION_DETAILS]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        configurations: {
          configurationDetails: { [key]: { $set: params[key] } },
        },
      });
    });
    return state;
  },
  [UPDATE_CONFIGURATION_REMOVED_ITEMS]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        configurations: {
          configurationDetails: {
            removedItems: { [key]: { $set: params[key] } },
          },
        },
      });
    });
    return state;
  },
  [UPDATE_CONFIGURATION_VALUES_DETAILS]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        configurations: {
          addValueDetails: { [key]: { $set: params[key] } },
        },
      });
    });
    return state;
  },
  [INIT_CONFIGURATION_DETAILS]: state => {
    return update(state, {
      configurations: {
        configurationDetails: {
          $set: initialState.configurations.configurationDetails,
        },
      },
    });
  },
  [UPDATE_CONFIGURATION_VIEW_VALUE_DETAILS]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        configurations: {
          viewValueDetails: { [key]: { $set: params[key] } },
        },
      });
    });
    return state;
  },
  [INIT_CONFIGURATION_REMOVE_VALUE]: state => {
    return update(state, {
      configurations: {
        viewValueDetails: {
          $set: initialState.configurations.viewValueDetails,
        },
      },
    });
  },
  [UPDATE_CURRICULUM_PROGRAMMES_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        curriculumProgrammesFilters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [INIT_CURRICULUM_PROGRAMMES_FILTERS]: state => {
    return update(state, {
      curriculumProgrammesFilters: {
        $set: initialState.curriculumProgrammesFilters,
      },
    });
  },
};

const initialState = {
  searchString: {
    orgnizationManagement: "",
    orgnizationApproval: "",
    userApproval: "",
    organizations: "",
    users: "",
    standards: "",
    configurations: "",
    configurationValue: "",
    configurationsValue: "",
    curriculumProgrammes: "",
    ruleSet: "",
  },
  // searchString:"",
  organizationSearchString: "",
  isLoading: {
    orgnizationManagement: false,
  },
  searchText: "",
  filters: {
    organizations: [],
    configurations: {
      configurationGroups: [],
      ownerTeam: [],
      status: [],
      controlParameterTypes: [],
    },
    standards: { subjectFilters: [], curriculumTypeFilters: [] },
    regionIds: REGION_FILTER_OPTIONS.map(region => region.value),
  },
  organizationFilters: {
    tab: "ALL_SCHOOLS",
    toddleBuddy: "",
    plan: "",
    transitionFilter: "",
    regionIds: REGION_FILTER_OPTIONS.map(region => region.value),
    isPaidOrganizationKey: "",
  },
  curriculumProgrammesFilters: {
    tab: "ALL_SCHOOLS",
    toddleBuddy: "",
    plan: [],
    status: [],
    transitionFilter: "",
    curriculumGroup: "",
    regionIds: [],
    isPaidOrganizationKey: "",
    curriculumUIDs: [],
    variants: [],
    toddleVersion: "",
  },
  teacherDetails: {
    id: null,
    firstName: "",
    profileImage: null,
    lastName: "",
    email: "",
  },
  teacherTab: "classes",
  removedCourses: [],
  manageCourseRoute: "courseList",
  teacherStep: 2,
  isActionLoading: false,
  passwordValidityStatus: {
    SCHOOL_CONTRACT_PASSWORD: false,
    TEMPLATE_DEPLOYMENT_AUTOMATION_TOOL_PASSWORD: false,
  },
  isLoadingPasswordState: false,
  configurations: {
    sortFields: { ID: { direction: "ASC", menuItemEntity: "ID" } },
    configurationDetails: {
      configuration: "",
      configurationGroup: null,
      description: "",
      defaultValue: "",
      valueType: null,
      dependentEntities: [],
      ownerTeam: "",
      aclControlParameterType: "",
      aclModules: [],
      aclPortalTypes: [],
      validityData: [],
      lockData: [],
      relationshipData: {},
      configurationView: { platform: null, view: {} },
      removedItems: {
        validityData: [],
        lockData: [],
      },
    },
    addValueDetails: {
      appTypes: [],
      entityGroups: [],
      settingValue: null,
      region: null,
    },
    viewValueDetails: {
      removedRowIds: [],
    },
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export const applyCustomColumnStyles = ({ workSheet }) => {
  const firstRow = workSheet.getRow(1);
  firstRow.eachCell(function (cell, columnNumber) {
    const column = workSheet.getColumn(columnNumber);
    if (_.includes(GRAY_OUT_COLUMNS, cell.value)) {
      column.eachCell(function (cell) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: hexToArgbObject({ hexColor: colors.neutral600 }),
        };

        cell.border = {
          top: {
            style: "thin",
            color: hexToArgbObject({ hexColor: colors.neutral500 }),
          },
          left: {
            style: "thin",
            color: hexToArgbObject({ hexColor: colors.neutral500 }),
          },
          bottom: {
            style: "thin",
            color: hexToArgbObject({ hexColor: colors.neutral500 }),
          },
          right: {
            style: "thin",
            color: hexToArgbObject({ hexColor: colors.neutral500 }),
          },
        };
      });
    }
    column.alignment = {
      vertical: "middle",
      horizontal: "left",
      wrapText: true,
    };
  });

  return workSheet;
};

export const createOrganizationAccount = (
  orgDetails,
  curriculumProgramFilters
) => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: createOrganizationAccountMutation,
        variables: { input: orgDetails, curriculumProgramFilters },
      });
      const { isSuccess, warning } = _.get(
        res,
        "data.platform.createOrganizationV2",
        {}
      );

      if (!isSuccess) {
        const message = _.get(warning, "message", "");
        throw new Error(message);
      }

      const account = _.get(
        res,
        "data.platform.createOrganizationV2.organization"
      );

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:action_successfully",
          locale_params: [
            { key: "label", value: "Account", isPlainText: true },
            { key: "action", value: "toastMsgs:created", isPlainText: false },
          ],
        })
      );
      return { isSuccess, account };
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const updateAccountDetails = (orgDetails, curriculumProgramFilters) => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: updateAccountDetailsMutation,
        variables: { input: orgDetails, curriculumProgramFilters },
      });
      const { isSuccess, warning } = _.get(
        res,
        "data.platform.updateOrganizationV2",
        {}
      );

      if (isSuccess) {
        const account = _.get(
          res,
          "data.platform.updateOrganizationV2.organization",
          []
        );

        dispatch(
          setToastMsg({
            type: "success",
            msg: "toastMsgs:action_successfully",
            locale_params: [
              { key: "label", value: "Account", isPlainText: true },
              { key: "action", value: "toastMsgs:updated", isPlainText: false },
            ],
          })
        );
        return { isSuccess, account };
      } else {
        const code = _.get(_.head(warning), "code", "");
        throw new Error(ERROR_CODE_TO_MSG_MAPPING[code]);
      }
    } catch (e) {
      dispatchError({
        dispatch,
        e,
        customMessage: !e.networkError ? _.get(e, "message") : null,
      });
      throw e;
    }
  };
};

export const deleteCurriculumProgram = orgDetails => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: deleteCurriculumProgramMutation,
        variables: { input: orgDetails },
      });
      const { isSuccess, warning } = _.get(
        res,
        "data.platform.updateOrganizationV2",
        {}
      );

      if (!isSuccess) {
        const message = _.get(warning, "message", "");
        throw new Error(message);
      }

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:action_successfully",
          locale_params: [
            { key: "label", value: "Program", isPlainText: true },
            { key: "action", value: "toastMsgs:deleted", isPlainText: false },
          ],
        })
      );
      return isSuccess;
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const getCurriculumProgramDataFromProgramId = ({
  id,
  isPlatformIdInitiallyPresent,
}) => {
  return async dispatch => {
    try {
      const data = await client.query({
        query: getCurriculumProgramByPlatformIdQuery,
        variables: {
          id,
        },
      });
      const queryData = _.get(
        data,
        "data.planner.curriculumProgramDataByPlatformId",
        {}
      );
      const errorMsg = _.get(queryData, "error.message", null);
      if (errorMsg && !isPlatformIdInitiallyPresent) {
        throw new Error(errorMsg);
      }
      dispatch(
        setToastMsg({
          msg: "Sync successful",
          locale_params: [
            {
              isPlainText: true,
            },
          ],
          type: "success",
        })
      );
      return queryData;
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: e.message,
          locale_params: [
            {
              isPlainText: true,
            },
          ],
          type: "error",
        })
      );
      throw e;
    }
  };
};

export const updateIdentityPermissions = ({ input, identityId }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const currentPortalType = _.get(state, "login.portalType", null);

    try {
      // Check if user is in China region - if so, block the mutation
      if (getIsChina()) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:permission_update_not_available_in_china",
            type: "error",
          })
        );
        return;
      }

      // Switch to eu-west-1 region for the mutation
      const euWestPortalType = PORTAL_TYPE_BY_REGION["eu-west-1"];
      dispatch(setPortalType(euWestPortalType));

      await client.mutate({
        mutation: bulkUpdateConfigurationMutation,
        variables: {
          input,
        },
        optimisticResponse: {
          platform: {
            setMultipleConfigurationValueForEntityGroups: true,
            __typename: "PlatformMutations",
          },
        },
        update: (
          cache,
          {
            data: {
              platform: { setMultipleConfigurationValueForEntityGroups },
            },
          }
        ) => {
          if (setMultipleConfigurationValueForEntityGroups) {
            cache.updateQuery(
              {
                query: getConfigurationQuery,
                variables: {
                  configurationEntityGroupFilters: [
                    {
                      configurationEntityGroups: [
                        {
                          entityId: identityId,
                          entityType: "IDENTITY",
                        },
                      ],
                      configurationGroups: ["IdentityAccess"],
                      configurations: [],
                    },
                  ],
                  isAdminPage: false,
                  isSettingsPage: false,
                  isCourseModuleSetting: false,
                  isAdminNotificationManager: false,
                },
              },
              data => {
                const configurationIndex = _.findIndex(
                  _.get(data, "platform.configuration.0.configurations", []),
                  { id: _.get(input, "0.id") }
                );

                if (configurationIndex === -1) {
                  return data;
                }

                const updatedValue = _.get(input, "0.value");
                return update(data, {
                  platform: {
                    configuration: {
                      0: {
                        configurations: {
                          [configurationIndex]: {
                            value: { $set: updatedValue },
                          },
                        },
                      },
                    },
                  },
                });
              }
            );
          }
        },
      });

      dispatch(
        setToastMsg({
          msg: "toastMsgs:permission_updated_successfully",
          type: "success",
        })
      );
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    } finally {
      // Always restore the original portal type
      dispatch(setPortalType(currentPortalType));
    }
  };
};
